import React from 'react'
import Loading from '../Loading'

interface Props {
  isLoading: boolean
  isError: boolean
  title?: string
  message?: string
  marginTop?: string
  classNameContainer?: string
}

export function WarningData({
  marginTop,
  isLoading,
  isError,
  classNameContainer,
  title = 'Houve um erro ao carregar os empreendimentos!',
  message = "Tente <a href='window.location.reload'>atualizar<a/> a página."
}: Props) {
  return (
    <div className={`${classNameContainer}`}>
      {isLoading && <div id="loadingBox" style={{ marginTop: marginTop }}></div>}
      {isError && (
        <div
          style={{ backgroundColor: 'rgba(255, 237, 213, 0.2)', marginTop: marginTop }}
          className="border-l-4 border-orange-500 text-orange-700 p-4"
          role="alert"
        >
          <p className="font-bold">{title}</p>
          <p>
            <span dangerouslySetInnerHTML={{ __html: message }}></span>
          </p>
        </div>
      )}
    </div>
  )
}
